// 페이지 제목을 동적으로 설정하는 유틸리티 함수

export const setPageTitle = (pageTitle) => {
  const baseTitle = 'RF4 데이터 사이트';
  
  if (pageTitle) {
    document.title = `${baseTitle} - ${pageTitle}`;
  } else {
    document.title = `${baseTitle}`;
  }
};

// 페이지별 제목 매핑 (실제 파일명 기준)
export const PAGE_TITLES = {
  home: '',  // 홈페이지는 기본 제목 사용
  records: '기록실',
  interactive_maps: '반응형 지도',
  fish: '어종 정보',
  groundbaits: '떡밥 정보',
  rod: '로드 정보',
  reels: '릴 정보',
  hook: '바늘 정보',
  line: '라인 정보',
  lure: '루어 정보',
  oil: '오일 정보',
  trophy: '트로피 정보',
  xptable: '경험치 테이블',
  tacklexp: '태클 경험치',
  price: '가격 정보',
  skill: '스킬 정보',
  qualification: '자격증 정보',
  updatelog: '업데이트 로그',
  ordertimer: '주문 타이머',
  vklink: 'VK 링크',
  'reset-password': '비밀번호 찾기',
  'verify-email': '이메일 인증',
  admin: '관리자 대시보드'
};

// 현재 경로에 따라 자동으로 제목 설정
export const setTitleFromPath = (pathname) => {
  // 경로에서 페이지 이름 추출 (첫 번째 세그먼트)
  const pageName = pathname.split('/')[1] || 'home';
  const pageTitle = PAGE_TITLES[pageName];
  setPageTitle(pageTitle);
};
